import { Framework } from '@/framework/instance';
import { getDifferentProps } from '@/utils/layer-kit';
import { IBaseOperateFlag, IBaseScaleData, ILayerProps } from '@/version-types';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 缩放操作
 */
export class ScaleOperate extends Framework {
    constructor(
        identity: string,
        private room: Room,
        private collaborators: Collaborators,
    ) {
        super(identity);
        this.room.onMessage(OperateType.Scale, this.onReceiveScaleOperate.bind(this));
    }

    /** 发送选中图层事件 */
    send(args: IBaseOperateFlag, data: IBaseScaleData, oldLayer: ILayerProps | null) {
        if (oldLayer) {
            const newLayer = this.framework.getLayer(data.layerId, true);
            const diffInfo = getDifferentProps(newLayer, oldLayer);
            this.room.throttleSendToAll(OperateType.Scale, [diffInfo, args.isEnd ? 1 : 0], args.isEnd);
            if (args.isEnd) {
                Object.keys(diffInfo).forEach((layerId) => {
                    this.room.syncBaseOperateAdapter.set(this.room.collaborators.getWsKey(), layerId);
                });
            }
        }
    }

    /** 收到选中图层事件回调 */
    private onReceiveScaleOperate({ fromWsMemberKey, data }: IEditMessage<[Record<string, any>, number]>) {
        const [diffInfo, isEnd] = data;
        Object.keys(diffInfo).forEach((layerId) => {
            if (isEnd) {
                this.room.syncBaseOperateAdapter.set(fromWsMemberKey, layerId);
            }
        });
    }
}
